function resetSliders(alt_text, media) {
  var $mainWrapper = $('[data-product-single-media-slider]');
  var $navWrapper  = $('[data-product-single-media-thumbs]');

  var mainInstance = window.mrkThis && window.mrkThis.flkty;
  var navInstance  = window.mrkThis && window.mrkThis.flktyNav;

  var mainOptions = mainInstance ? $.extend(true, {}, mainInstance.options) : {};
  var navOptions  = navInstance  ? $.extend(true, {}, navInstance.options)  : {};

  if (mainInstance) {
    mainInstance.destroy();
    window.mrkThis.flkty = null;
  }

  if (navInstance) {
    navInstance.destroy();
    window.mrkThis.flktyNav = null;
  }

  var rawHtml = $('#mrk-product-data').html() || '';
  var $raw = $('<div>' + rawHtml + '</div>');

  if (alt_text && alt_text !== '') {
    var $matches = $raw.find('.mrk-slide-item[data-alt="' + alt_text + '"], .mrk-slide-item[data-alt="show-all-time"]');
    if ($matches.length) {
      $raw.find('.mrk-slide-item').not($matches).remove();
    }
  }

  var $newMain = $raw.find('[data-product-single-media-slider]').first();
  var $newNav  = $raw.find('[data-product-single-media-thumbs]').first();

  if ($newMain.length) {
    $mainWrapper.html($newMain.html());
  }
  if ($newNav.length) {
    $navWrapper.html($newNav.html());
  }

  var FlickityClass = window.flickity || window.Flickity;
  if (!FlickityClass) return;

  window.mrkThis.flkty    = new FlickityClass($mainWrapper[0], mainOptions);
  window.mrkThis.flktyNav = new FlickityClass($navWrapper[0], navOptions);
  let index = $(`.product-single__thumbnail[data-alt="${media.alt}"]:eq(0)`).index();
  console.log(index, media);
  // Slide both sliders
  if(index > -1){
    window.mrkThis.flkty.select(index);
    window.mrkThis.flktyNav.select(index);
  }

}
function updateImages(alt_text, media, url) {
  var $mainWrapper = $('[data-product-single-media-slider]');
  var $navWrapper  = $('[data-product-single-media-thumbs]');

  window.mrkThis = window.mrkThis || {};

  var mainInstance = window.mrkThis.flkty;
  var navInstance  = window.mrkThis.flktyNav;

  var mainOptions = mainInstance ? $.extend(true, {}, mainInstance.options) : {};
  var navOptions  = navInstance  ? $.extend(true, {}, navInstance.options)  : {};

  // ---------- ADD LOADING STATE ----------
  var mainHeight = $mainWrapper.outerHeight() || 300;
  var navHeight  = $navWrapper.outerHeight() || 120;

  $mainWrapper
    .addClass('mrk-loading')
    .css('min-height', mainHeight)
    .append('<div class="mrk-loader"></div>');

  $navWrapper
    .addClass('mrk-loading')
    .css('min-height', navHeight)
    .append('<div class="mrk-loader"></div>');

  // ---------- DESTROY OLD SLIDERS ----------
  if (mainInstance && typeof mainInstance.destroy === 'function') {
    mainInstance.destroy();
    window.mrkThis.flkty = null;
  }
  if (navInstance && typeof navInstance.destroy === 'function') {
    navInstance.destroy();
    window.mrkThis.flktyNav = null;
  }

  var FlickityClass = window.flickity || window.Flickity;
  if (!FlickityClass) return $.Deferred().reject('Flickity not found').promise();

  var pickedAlt = (media && media.alt != null)
    ? String(media.alt)
    : String(alt_text || '');

  // ---------- FETCH & UPDATE ----------
  return $.get(url).then(function (html) {
    var $raw = $('<div/>').append($.parseHTML(html, document, true));

    if (pickedAlt) {
      var safeAlt = pickedAlt.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      var $matches = $raw.find(
        '.mrk-slide-item[data-alt="' + safeAlt + '"], .mrk-slide-item[data-alt="show-all-time"]'
      );
      if ($matches.length) {
        $raw.find('.mrk-slide-item').not($matches).remove();
      }
    }

    var $newMain = $raw.find('[data-product-single-media-slider]').first();
    var $newNav  = $raw.find('[data-product-single-media-thumbs]').first();

    if ($newMain.length) $mainWrapper.html($newMain.html());
    if ($newNav.length)  $navWrapper.html($newNav.html());

    // ---------- INIT SLIDERS ----------
    window.mrkThis.flkty    = new FlickityClass($mainWrapper[0], mainOptions);
    window.mrkThis.flktyNav = new FlickityClass($navWrapper[0], navOptions);

    var index = -1;
    if (pickedAlt) {
      index = $navWrapper
        .find('[data-alt="' + safeAlt + '"]')
        .first()
        .index();
    }

    if (index > -1) {
      window.mrkThis.flkty.select(index);
      window.mrkThis.flktyNav.select(index);
    }

    return { index: index, alt: pickedAlt };
  }).always(function () {
    // ---------- REMOVE LOADER ----------
    $mainWrapper.removeClass('mrk-loading').css('min-height', '');
    $navWrapper.removeClass('mrk-loading').css('min-height', '');
    $mainWrapper.find('.mrk-loader').remove();
    $navWrapper.find('.mrk-loader').remove();
  });
}


function updateVariant(container,allowUpdateImages){
  var variantId = null;
  var addon_id = null;
  var selectedOptions = [];
  var options = $(this).find('select').val();
  $(container).find('input:not(".mrk-shade-item"):checked').each(function () {
      selectedOptions.push($(this).val());
      $(this).parents('.variant-picker__option').find('.mrk-selected-value').html($(this).val())
  });
  // Fetch variants from the JSON script tag within the quantity-breaks element
  var variants = window.mrkVariants;
  variants.forEach(function (variant) {
      var options = variant.options;
      if (JSON.stringify(options) === JSON.stringify(selectedOptions)) {
          var featured_image = variant.featured_image.src || variant.featured_image,
          featured_image = featured_image + '&width=100'
          addon_image = variant.straight_extension?.featured_image.src || variant.straight_extension?.featured_image;
          addon_image = addon_image  + '&width=100';
          addon_id = variant.straight_extension?.id;
          $('.mrk-main-image').attr('src', featured_image);
          $('.mrk-addon-image').attr('src', addon_image);
          $('[data-swatches-label] span').html(variant.options[0]);
          var alt_text = variant.featured_media?.alt;
          if(allowUpdateImages)
          updateImages(alt_text,variant.featured_media,`${variant.product_url}?variant=${variant.id}&section_id=${$(container).attr('section-id')}`);
      }
  });

  if(addon_id != null)
    $('.mrk-addon').html(`<input name="items[1][id]" type="hidden" value="${addon_id}" />`);
  else
    $('.mrk-addon').html('');
}
$('mrk-variant-picker').on('change', function(e){
  if($(e.target).hasClass('mrk-shade-item')){
    return;
  }
  var updateImages = true;
  if($(e.target).hasClass('product__selectors')){
    updateImages = false;
  }
  updateVariant($(this),updateImages)
});
$(document).on('change', '.mrk-shade-item', function () {
    const selectedShade = $(this).val().toLowerCase();

    if (selectedShade === 'Toutes') {
        $('.mrk-color-item').show();
    } else {
        $('.mrk-color-item').hide().filter(function () {
            const shades = $(this).attr('shades') || '';
            const shadeArray = shades.toLowerCase().split(',').map(s => s.trim());
            return shadeArray.includes(selectedShade);
        }).show();
    }
});
$('mrk-variant-picker').trigger('change');
setTimeout(function(){
  $('.product-gallery__thumbnail:eq(0)').click()
},1);
$(document).on('click', '.mrk-swatches-wrapper button', function () {
    var $wrapper = $(this).closest('.mrk-swatches-wrapper');

    if ($(this).attr('aria-label') === 'next') {
        $wrapper.animate({ scrollLeft: $wrapper.scrollLeft() + 100 }, 300);
    } else {
        $wrapper.animate({ scrollLeft: $wrapper.scrollLeft() - 100 }, 300);
    }
});

$(document).ready(function () {
  $(document).on('click', '.mrk-help-trigger', function () {
    var popup = $(this).attr('popup'); 
    $('#' + popup).fadeIn(200);
    $('body').addClass('hidden-item');
  });
  $(document).on('click', '.mrk-close-popup', function () {
    $(this).closest('.mrk-help-popup').fadeOut(200);
    $('body').removeClass('hidden-item');
  });
  $(document).on('click', '.mrk-help-popup', function (e) {
    if (e.target !== this) return;
    $(this).fadeOut(200);
    $('body').removeClass('hidden-item');
  });
});
